import { useEntityCompleteness } from "./EntityCompletenessContext"
import { EntityCompletenessPanel } from "./EntityCompletenessPanel"

export function EntityCompletenessSlot() {
  const state = useEntityCompleteness()
  if (!state) {
    return null
  }
  return <EntityCompletenessPanel state={state} />
}
